module.exports = __webpack_public_path__ + "img/PLUM.87a18a98.png";